/**
 * FERP Portal - Contract List Page (DRR-074: Tabulator DRY Template)
 *
 * CONFIGURE Phase: SLA terms, resolution commitments, and service level agreements.
 * Delegates to TabulatorPrimitiveManager for consistent CRUD across all 25 primitives.
 */

import { TabulatorPrimitiveManager } from '@/components/primitives/TabulatorPrimitiveManager';

export function ContractListPage() {
  return <TabulatorPrimitiveManager primitiveType="contract" />;
}

export default ContractListPage;
